import React from 'react'
import NewsCards from './NewsCards'
// import news from './SampleNews.json'




export default function ALlNews({ articles,country,category,search,mode}) {
  return (
    <div className={` ${mode==="light"?"bg-body-tertiary":"bg-dark text-white"} `} data-bs-theme={mode==="light"?"light":"dark"} style={{minHeight:"100vh", marginTop:"60px"}}>
    <h1 className='mx-4 py-3' style={{color:"red"}}>
      Top Headlines {category ? ` - ${category.charAt(0).toUpperCase() + category.slice(1)}` : ""} {country ? ` - ${country.toUpperCase()}` : ""} {search ? ` - Search: "${search}"` : ""}
    </h1>
   <div className="row py-3 mx-4">
    {articles.map((article, index) => (
            <NewsCards key={article.article_id} newstitle={article.title} newstext={article.description} newsauthor={article.author} newsurl={article.link} newsimg={article.image_url}/>
        
      ))}
   </div>
    </div>
  )
}
